// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-af441262] .el-form-item {\n  margin-bottom: 26px !important;\n}\n[data-v-af441262] .el-form-item__error {\n  padding-left: 10px !important;\n}", ""]);
// Exports
module.exports = exports;
